module.exports = __webpack_public_path__ + "img/icons8-alfa-romeo.30e46f46.svg";